// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__T4LOs"};